import { observer } from "mobx-react";
import { h } from "preact";
import { ISO_WEEKDAY_NAMES, } from "restaumatic-client";
import { t, translate } from "restaumatic-client";
import PreactPopover from "../../components/PreactPopover";
function WeeklySchedulePopover(props) {
    const { id, children, weeklySchedule } = props;
    const popoverId = `weekly-schedule-popover-${id}`;
    const weekdayNames = ISO_WEEKDAY_NAMES;
    return (h("span", { class: "m-availability js-popover-container" },
        h(PreactPopover, { target: `#${popoverId}`, trigger: "click", className: "m-availability__button", popoverClass: "m-popover m-popover--medium" }, children),
        h("div", { id: popoverId, style: "display: none;" },
            h("span", { class: "m-availability__popover__title--unavailable" }, translate(t.restaurants.menu.unavailable_dish)),
            h("button", { type: "button", class: "close js-dismiss-popover" }, "\u00D7"),
            h("div", { class: "clearfix" }),
            h("div", { class: "multi-column m-popover__content m-availability__sheet" }, weekdayNames.map((weekday) => (h(ScheduleWeekDay, { key: weekday, weekday: weekday, weeklySchedule: weeklySchedule })))))));
}
const ScheduleWeekDay = observer((props) => {
    const { weekday, weeklySchedule } = props;
    const translatedWeekday = translate(t.date.day.abbr_names[weekday.toLowerCase()]);
    const { isEmpty, isFull, timeRanges } = weeklySchedule.dayOfWeek(weekday);
    const showTimeRanges = !isFull && !isEmpty && timeRanges.length > 0;
    return (h("div", null,
        h("div", { class: "m-availability__sheet__header" }, translatedWeekday),
        h("div", { class: "m-availability__sheet__data" },
            isFull && h("i", { class: "icon-ok text-success" }),
            isEmpty && h("i", { class: "icon-remove text-danger" }),
            showTimeRanges && (h("span", { class: "text-success" }, timeRanges.map((timeRange) => timeRange.toString()).join(", "))))));
});
export default observer(WeeklySchedulePopover);
